import React from 'react'

import { ArchiveIcon, ClockIcon } from '@primer/octicons-react'
import { Link } from 'react-router-dom'

import MarkdownDisplay from './markdown/markdown-display.component'

export default function TopicCard(props) {
    if (!props.title || props.progress === undefined || !props.id || props.taskCount === undefined || props.finishedTasks === undefined) {
        return (
            <>
                <div className="card-container">
                    <div className="card">
                        <div className="card-body">
                            <h5 className="card-title text-danger">Fehler beim Laden der Daten</h5>
                        </div>
                    </div>
                </div>
            </>
        )
    }

    return (
        <>
            <div className="card-container">
                <div className="card">
                    <div className="card-body">
                        <h5 className="card-title">{props.title}</h5>
                        {
                            props.progress === 0 ?
                            <h6 className="card-subtitle mb-2 text-danger"><ClockIcon size={16}/>&nbsp;&nbsp;Noch nicht gestartet</h6>
                            :
                            props.progress < 100 ?
                            <h6 className="card-subtitle mb-2 text-warning"><ClockIcon size={16}/>&nbsp;&nbsp;In Arbeit</h6>
                            :
                            <h6 className="card-subtitle mb-2 text-info"><ClockIcon size={16}/>&nbsp;&nbsp;Abgeschlossen</h6>
                        }
                        
                        {
                            props.info ?
                            <MarkdownDisplay content={props?.info} />
                            :
                            <div className="mb-2">
                                <small className="text-muted">Keine Beschreibung verfügbar</small>
                            </div>
                        }
                        <div className="progress" aria-label={`Fortschritt ${props.progress}%`} style={{width: 100 + '%', zIndex: 1, position: "initial"}}>
                            <div className="progress-bar" role="progressbar" style={{width: props.progress + "%"}} aria-valuenow={props.progress} aria-valuemin="0" aria-valuemax="100"></div>
                        </div>
                        <div className="chip-list" aria-label={`${props.taskCount - props.finishedTasks} Aufgaben verbleibend`}>
                            <div className="chip">
                                <ArchiveIcon size={16} />
                                <span>{props.taskCount - props.finishedTasks} verbleibend</span>
                            </div>
                        </div>

                        <Link to={"/training/topic/" + props.id} className="btn btn-primary">Anschauen</Link>
                    </div>
                </div>
            </div>
        </>
    )
}
